import { TRANSLATE_FIELD_QUERY } from "@app/shared-core/general/translate/queries/translate-field.query";

/** GraphQL selection for a group in the reservation source economic conditions: its name, description and own amounts. */
export const GROUP_ECONOMIC_CONDITIONS_QUERY = `
  id
  name
  description { ${TRANSLATE_FIELD_QUERY} }
  enabled
  deposit
  theftResponsibility
  damageResponsibilityType
`;
